"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadAllContractConsumptions = exports.ContractConsumptionsActionType = void 0;
var _contractApi = require("../../../api-factory/contractApi");
var ContractConsumptionsActionType = exports.ContractConsumptionsActionType = /*#__PURE__*/function (ContractConsumptionsActionType) {
  ContractConsumptionsActionType["LOAD_ALL_CONTRACT_CONSUMPTIONS"] = "api/reducer/LOAD_ALL_CONTRACT_CONSUMPTIONS";
  ContractConsumptionsActionType["LOADING"] = "api/reducer/LOADING";
  return ContractConsumptionsActionType;
}({});
var loadAllContractConsumptions = exports.loadAllContractConsumptions = function loadAllContractConsumptions(dispatch, contractId) {
  dispatch({
    type: ContractConsumptionsActionType.LOADING
  });
  (0, _contractApi.getContractConsumptions)(contractId).then(function (response) {
    dispatch({
      type: ContractConsumptionsActionType.LOAD_ALL_CONTRACT_CONSUMPTIONS,
      content: response.data.content
    });
  });
};